<template>
  <div
    class="profile-wrapper"
    style="
      flex: 1;
      flex-direction: column;
      display: flex;
      max-width: 100%;
      height: 100vh;
    "
  >
    <el-dialog
      :visible.sync="showHistory"
      title="Modül Konfigrasyon Değişim Günlüğü"
    >
      <ul>
        <li v-for="i in configHistory">
          <div
            style="color: white; padding: 10px 20px"
            v-if="i.currentSpeed || i.speed"
          >
            HIZ: {{ i.currentSpeed }}
            {{ i.speed }}
          </div>
          <div
            style="color: white; padding: 10px 20px"
            v-if="i.level || i.currentLevel"
          >
            LEVEL:
            {{ i.level || i.currentLevel }}
          </div>
          <div
            style="color: white; padding: 10px 20px"
            v-if="i.mode || i.currentMode"
          >
            MODE:
            {{ i.mode || i.currentMode }}
          </div>
        </li>
      </ul>
    </el-dialog>
    <div
      style="
        width: 100%;
        font-size: 24px;
        background-color: #1c449c;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 4px 15px;
      "
      class="dark-inverted"
    >
      <span style="font-weight: bold; color: white"
        >{{
          timer > 0
            ? moment()
                .set({ second: 0, hour: 0, minute: 0 })
                .add({ seconds: timer })
                .format("mm:ss")
            : ""
        }}

        <a
          href="javascript:;"
          style="
            color: white;
            font-size: 20px;
            margin-left: 15px;
            margin-right: 15px;
          "
          @click="next"
        >
          <i class="fas fa-arrow-right"></i>
        </a>

        <a
          v-if="$store.state.user.tester == 1"
          href="javascript:;"
          style="
            color: white;
            font-size: 20px;
            margin-left: 15px;
            margin-right: 15px;
          "
          @click="timer += 10"
        >
          <i class="fas fa-plus"></i>
        </a>
        <a
          v-if="$store.state.user.tester == 1"
          href="javascript:;"
          style="color: white; font-size: 20px"
          @click="pause = !pause"
        >
          <i class="fas fa-play" v-if="pause"></i
          ><i class="fas fa-pause" v-if="!pause"></i>
        </a>
      </span>

      <span style="display: flex; align-items: center">
        <span
          v-if="steps != null"
          style="font-weight: bold; color: white; margin-left: 10px"
          >{{ currentStep }}/{{ steps.length }}</span
        >

        <span
          style="color: white; font-size: 17px; margin-left: 10px"
          v-if="activeStep"
          >{{ activeStep.program.module.category }} >
          {{ activeStep.program.module.title }}</span
        >
        <a
          href="javascript:;"
          style="color: white; margin-left: 30px"
          @click="fullScreen"
        >
          <i class="fas fa-expand"></i>
        </a>

        <a
          href="javascript:;"
          style="color: white; margin-left: 20px; margin-right: 10px"
          @click="
            $store.state.selectedTick2 == 'sessiz'
              ? ($store.state.selectedTick2 = 'Ses1')
              : ($store.state.selectedTick2 = 'sessiz')
          "
        >
          <i
            :class="
              'fas fa-' +
              ($store.state.selectedTick2 == 'sessiz'
                ? 'volume-mute'
                : 'volume-up')
            "
          ></i>
        </a>

        <label
          class="dark-mode ml-auto"
          style="
            transform: scale(0.6);
            margin-left: 10px;
            display: inline-block;
          "
        >
          <input type="checkbox" v-model="$store.state.darkmode" />
          <span></span>
        </label>

        <a
          @click="$store.state.scale -= 0.05"
          href="javascript:;"
          style="color: white; margin-left: 10px; margin-right: 10px"
        >
          <i class="fas fa-search-minus"></i>
        </a>

        <a
          @click="$store.state.scale += 0.05"
          href="javascript:;"
          style="color: white; margin-left: 10px; margin-right: 10px"
        >
          <i class="fas fa-search-plus"></i>
        </a>

        <a
          @click="back"
          href="javascript:;"
          style="color: white; margin-left: 30px; margin-right: 10px"
        >
          <i class="fas fa-times"></i>
        </a>
      </span>
    </div>
    <div
      v-if="$refs.activeModule && $store.state.user.tester == 1"
      style="
        width: 100%;
        background-color: #333;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
      "
    >
      <div style="display: flex; align-items: center; justify-content: center">
        <div
          style="color: white; padding: 10px 20px"
          v-if="$refs.activeModule.currentSpeed || $refs.activeModule.speed"
        >
          HIZ: {{ $refs.activeModule.currentSpeed }}
          {{ $refs.activeModule.speed }}
        </div>
        <div
          style="color: white; padding: 10px 20px"
          v-if="$refs.activeModule.level || $refs.activeModule.currentLevel"
        >
          LEVEL:
          {{ $refs.activeModule.level || $refs.activeModule.currentLevel }}
        </div>
        <div
          style="color: white; padding: 10px 20px"
          v-if="$refs.activeModule.mode || $refs.activeModule.currentMode"
        >
          MODE:
          {{ $refs.activeModule.mode || $refs.activeModule.currentMode }}
        </div>
        <div
          @click="$refs.activeModule.settings = true"
          style="color: white; padding: 10px 20px"
        >
          <i class="fas fa-cog"></i>
        </div>
        <a
          href="javascript:;"
          style="color: white; font-size: 17px"
          @click="next"
          v-if="$store.state.user.tester == 1"
        >
          <i class="fas fa-arrow-right"></i>
        </a>
        <a
          href="javascript:;"
          style="color: white; font-size: 17px"
          @click="showHistory = true"
          v-if="configHistory.length > 0"
        >
          <i class="fas fa-history"></i>
        </a>
      </div>
      <div style="color: white; padding-right: 20px">
        <span
          style="
            display: inline-block;
            border: 1px solid rgba(255, 255, 255, 0.3);
            border-radius: 5px;
            padding: 0px 5px;
            margin-right: 10px;
          "
          v-for="i in Object.keys(activeStepProgram)"
          v-if="
            activeStepProgram[i] != null &&
            i != 'module' &&
            i != 'program_id' &&
            i != 'module_id' &&
            i != 'course_id' &&
            i != 'createdAt' &&
            i != 'updatedAt'
          "
        >
          {{ i }}: {{ activeStepProgram[i] }}
        </span>
      </div>
    </div>
    <div
      v-if="started"
      style="
        display: flex;
        flex: 1;
        width: 100%;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      "
      :style="{
        transform: 'scale(' + $store.state.scale + ')',
        transformOrigin: 'top center',
      }"
    >
      <GozEsnetme
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'goz-esnetme'"
      ></GozEsnetme>
      <IkiliUcluBlok
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'ikili-uclu-blok'"
      ></IkiliUcluBlok>
      <EsnekGormeAlani
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'esnek-gorme-alani'"
      ></EsnekGormeAlani>
      <GozEsnekligi
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'goz-esnekligi'"
      ></GozEsnekligi>
      <GozRitim
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'goz-ritim'"
      ></GozRitim>
      <AcilanNesnelerYatay
        direction="horizontal"
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'acilan-nesneler-yatay'"
      ></AcilanNesnelerYatay>
      <KareGormeAlani
        direction="vertical"
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'kare-gorme-alani'"
      ></KareGormeAlani>
      <HarfSayma
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'harf-sayma'"
      ></HarfSayma>
      <FarkliOlan
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'farkli-olan'"
      ></FarkliOlan>
      <KelimeAvi
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'kelime-avi'"
      ></KelimeAvi>
      <CokluFokus
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'coklu-fokus'"
      ></CokluFokus>
      <CevreFokus
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'cevre-fokus'"
      ></CevreFokus>
      <BlokOkuma
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'blok-okuma'"
      ></BlokOkuma>
      <GolgeliOkuma
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'golgeli-okuma'"
      ></GolgeliOkuma>
      <GrupOkuma
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'grup-okuma'"
      ></GrupOkuma>
      <Takistoskop
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'takistoskop'"
      ></Takistoskop>
      <ZikZak
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'zikzak'"
      ></ZikZak>
      <Siralama
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'siralama'"
      ></Siralama>
      <DuzeltBakalim
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'duzelt-bakalim'"
      ></DuzeltBakalim>
      <BenzerKelimeler
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'benzer-kelimeler'"
      ></BenzerKelimeler>
      <EsAnlamlilar
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'es-anlamlilar'"
      ></EsAnlamlilar>
      <HangisiBuyuk
        :config="activeStepProgram"
        ref="activeModule"
        v-if="activeStep.program.module.slug == 'hangisi-buyuk'"
      ></HangisiBuyuk>
    </div>
    <div
      v-else
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        flex: 1;
      "
      class="dark-inverted"
    >
      <h1 style="font-size: 20px">Egzersiz {{ currentStep }}</h1>
      <h1
        style="font-size: 32px; font-weight: bold; margin-top: 15px"
        v-if="activeStep"
      >
        {{ activeStep.program.module.title }}
      </h1>
      <h2 style="font-size: 18px" v-if="activeStep">
        SIRA: {{ activeStep.order_no }}
      </h2>
      <h2 style="font-size: 18px" v-if="activeStep">
        {{ activeStep.program.module.category }}
      </h2>
      <h3 style="font-size: 20px; margin-top: 15px" v-if="activeStep">
        {{ activeStep.program.seconds }} saniye
      </h3>
      <el-button round type="primary" class="mt-5" @click="start"
        >BAŞLA</el-button
      >
    </div>
  </div>
</template>

<script>
import GozEsnetme from "@/components/modules/GozEsnetme";
import IkiliUcluBlok from "@/components/modules/IkiliUcluBlok";
import EsnekGormeAlani from "@/components/modules/EsnekGormeAlani";
import GozEsnekligi from "@/components/modules/GozEsnekligi";
import GozRitim from "@/components/modules/GozeRitim";
import AcilanNesnelerYatay from "@/components/modules/AcilanNesnelerYatay";
import KareGormeAlani from "@/components/modules/KareGormeAlani";
import HarfSayma from "@/components/modules/HarfSayma";
import FarkliOlan from "@/components/modules/FarkliOlan";
import KelimeAvi from "@/components/modules/KelimeAvi";
import CokluFokus from "@/components/modules/CokluFokus";
import CevreFokus from "@/components/modules/CevreFokus";
import BlokOkuma from "@/components/modules/BlokOkuma";
import GolgeliOkuma from "@/components/modules/GolgeliOkuma";
import GrupOkuma from "@/components/modules/GrupOkuma";
import Takistoskop from "@/components/modules/Takistoskop";
import ZikZak from "@/components/modules/ZikZak";
import Siralama from "@/components/modules/Siralama";
import DuzeltBakalim from "@/components/modules/DuzeltBakalim";
import BenzerKelimeler from "@/components/modules/BenzerKelimeler";
import EsAnlamlilar from "@/components/modules/EsAnlamlilar";
import HangisiBuyuk from "@/components/modules/HangisiBuyuk";
import axios from "axios";
import $ from "jquery";
export default {
  components: {
    EsAnlamlilar,
    BenzerKelimeler,
    GozEsnetme,
    IkiliUcluBlok,
    EsnekGormeAlani,
    GozEsnekligi,
    GozRitim,
    AcilanNesnelerYatay,
    KareGormeAlani,
    HarfSayma,
    FarkliOlan,
    KelimeAvi,
    CokluFokus,
    CevreFokus,
    BlokOkuma,
    GolgeliOkuma,
    GrupOkuma,
    Takistoskop,
    ZikZak,
    Siralama,
    DuzeltBakalim,
    HangisiBuyuk,
  },
  name: "CourseTest",
  data() {
    return {
      currentStep: 1,
      steps: null,
      started: false,
      interval: null,
      timer: 0,
      moment,
      height: 0,
      pause: false,
      configHistory: [],
      showHistory: false,
    };
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    next() {
      this.timer = 1;
    },
    back() {
      if (this.timer > 0) {
        if (
          confirm(
            "Egzersiz henüz bitmedi, eğer çıkarsanız bu egzersizin verileri kaydedilmeyecek."
          )
        ) {
          this.$router.push({ name: "Courses" });
        }
      } else {
        this.$router.push({ name: "Courses" });
      }
    },
    fullScreen(r) {
      return;
      var isInFullScreen =
        (document.fullscreenElement && document.fullscreenElement !== null) ||
        (document.webkitFullscreenElement &&
          document.webkitFullscreenElement !== null) ||
        (document.mozFullScreenElement &&
          document.mozFullScreenElement !== null) ||
        (document.msFullscreenElement && document.msFullscreenElement !== null);

      var docElm = document.documentElement;
      if (!isInFullScreen) {
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen();
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen();
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen();
        } else if (docElm.msRequestFullscreen) {
          docElm.msRequestFullscreen();
        }
      } else {
        if (r == true) {
          return;
        }
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    },
    start() {
      this.fullScreen(true);
      this.started = true;
      this.timer = this.activeStep.program.seconds;
      this.interval = setInterval(() => {
        if (this.pause) return;
        this.timer -= 1;

        if (this.timer == 0) {
          clearInterval(this.interval);
          this.currentStep += 1;
          this.started = false;
          return;
          if (this.currentStep == this.steps.length) {
            axios
              .post("course/doneDay", {
                id: this.$route.params.course_id,
                step_id: this.activeStep.step_id,
                course_id: this.activeCourse.course_id,
              })
              .then((x) => {
                var config = this.activeStep.program;
                var stats = {
                  totalTrue: 0,
                  totalFalse: 0,
                  totalClick: 0,
                  totalItem: 0,
                  totalTrueItem: 0,
                  totalPickedTrueItem: 0,
                };

                Object.keys(stats).map((key) => {
                  if (this.$refs.activeModule[key] != undefined) {
                    stats[key] = this.$refs.activeModule[key];
                  }
                });

                Object.keys(config).map((key) => {
                  if (this.$refs.activeModule[key] != undefined)
                    config[key] = this.$refs.activeModule[key];
                });

                axios
                  .post("course/done", {
                    id: this.$route.params.course_id,
                    step_id: this.activeStep.step_id,
                    course_id: this.activeCourse.course_id,
                    config,
                    stats,
                    reactions: this.$refs.activeModule.reactions || [],
                    firstReactions:
                      this.$refs.activeModule.firstReactions || [],
                  })
                  .then((res) => {
                    alert("Bugünkü Egzersizleri Bitirdiniz.");
                    this.$router.back();
                    return;
                  });
              });
          } else {
            var config = this.activeStep.program;

            var stats = {
              totalTrue: 0,
              totalFalse: 0,
              totalClick: 0,
              totalItem: 0,
              totalTrueItem: 0,
              totalPickedTrueItem: 0,
            };

            Object.keys(stats).map((key) => {
              if (this.$refs.activeModule[key] != undefined) {
                stats[key] = this.$refs.activeModule[key];
              }
            });

            Object.keys(config).map((key) => {
              if (this.$refs.activeModule[key] != undefined)
                config[key] = this.$refs.activeModule[key];
            });

            axios
              .post("course/done", {
                id: this.$route.params.course_id,
                step_id: this.activeStep.step_id,
                course_id: this.activeCourse.course_id,
                config,
                stats,
                reactions: this.$refs.activeModule.reactions || [],
                firstReactions: this.$refs.activeModule.firstReactions || [],
              })
              .then((res) => {
                this.currentStep += 1;
                this.started = false;
              });
          }
        }
      }, 1000);
    },
  },
  watch: {
    "activeStep.program.module.slug": function () {
      this.pause = false;
    },
  },
  async created() {
    this.$root.$on("pause", (s) => {
      this.pause = s;
    });

    this.$root.$on("done", () => {
      this.pause = false;
      this.timer = 1;
    });

    var course = this.$store.state.courses.find(
      (k) => k.id == this.$route.params.course_id
    );

    if (course == undefined || course == null) {
      await axios.get("course/list").then((res) => {
        this.$store.state.courses = res.data.data;
        course = this.$store.state.courses.find(
          (k) => k.id == this.$route.params.course_id
        );
      });
    }

    this.steps = _.orderBy(
      course.steps.filter((k) => k.program.step == this.$route.params.day),
      ["step", "order_no"],
      ["asc", "asc"]
    );

    this.currentStep = parseInt(this.$route.params.step);
    return;

    var step = course.steps.find((k) => k.finishedAt != null);
    if (step == null) {
      this.currentStep = 1;
      this.steps = _.orderBy(
        course.steps.filter((k) => k.program.step == 1),
        ["step", "order_no"],
        ["asc", "asc"]
      );
    }
    var last_finished_step = step.program.step;
    console.log(last_finished_step);

    // is last step finished?
    var is_last_step_finished =
      course.steps.filter(
        (k) => k.program.step == last_finished_step && k.finishedAt != null
      ).length ==
      course.steps.filter((k) => k.program.step == last_finished_step).length;

    if (is_last_step_finished) {
      // check date is today
      if (step.finishedAt.indexOf(moment().format("YYYY-MM-DD")) != -1) {
        return "today_finished";
      } else {
        this.currentStep = step.program.step + 1;
        this.steps = _.orderBy(
          course.steps.filter((k) => k.program.step == step.program.step + 1),
          ["step", "order_no"],
          ["desc", "desc"]
        );
        this.currentStep = steps.filter((k) => k.finishedAt != null).length + 1;

        return;
      }
    } else {
      var steps = _.orderBy(
        course.steps.filter((k) => k.program.step == step.program.step),
        ["step", "order_no"],
        ["asc", "asc"]
      );
      // find last step

      this.currentStep = steps.filter((k) => k.finishedAt != null).length + 1;
      this.steps = steps;
    }
  },
  computed: {
    activeStep() {
      if (this.steps == null || this.steps.length == 0) return {};
      return this.steps[this.currentStep - 1];
    },
    activeStepProgram() {
      var config = this.activeStep.program;

      // find last config

      var last_config = this.activeCourse.last_config.find(
        (k) => k.module_id == config.module_id
      );

      if (
        last_config != null &&
        last_config != undefined &&
        config.auto_level == 1
      ) {
        "questionMode,questionModeLevel,speed,level,mode,row,col,image,direction"
          .split(",")
          .map((k, index) => {
            if (
              config[k] !== undefined &&
              (config[k] === null || config[k] === "") &&
              last_config[k] !== null &&
              last_config[k] !== ""
            ) {
              config[k] =
                index <= 7 ? parseInt(last_config[k]) : last_config[k];
            }

            if (
              config["questionMode"] == 1 &&
              last_config["questionModeLevel"] == null &&
              config["questionModeLevel"] == null
            ) {
              var last_config_question_mode =
                this.activeCourse.last_config.find(
                  (k) =>
                    k.module_id == config.module_id &&
                    k.questionModeLevel != null
                );
              config["questionModeLevel"] =
                last_config_question_mode["questionModeLevel"];
            }
          });

        Object.keys(this.activeStep.program).map((key) => {
          if (typeof config[key] === "string") {
            if (!isNaN(parseInt(config[key]))) {
              config[key] = parseInt(config[key]);
            }
          }
        });

        return config;
      } else {
        Object.keys(this.activeStep.program).map((key) => {
          if (typeof config[key] === "string") {
            if (!isNaN(parseInt(config[key]))) {
              config[key] = parseInt(config[key]);
            }
          }
        });

        return config;
      }
    },
    activeCourse() {
      return this.$store.state.courses.find(
        (k) => k.id == this.$route.params.course_id
      );
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/CourseTest.vue